// Environment-specific configuration
// This file contains all environment-specific settings for the frontend

const environments = {
  dev: {
    apiBaseUrl: 'https://dev.practicum.jackbritchford.com/api',
    environment: 'development',
    enableDebugMode: true,
    logLevel: 'debug'
  },
  test: {
    apiBaseUrl: 'https://test.practicum.jackbritchford.com/api',
    environment: 'test',
    enableDebugMode: true,
    logLevel: 'info'
  },
  prod: {
    apiBaseUrl: 'https://practicum.jackbritchford.com/api',
    environment: 'production',
    enableDebugMode: false,
    logLevel: 'error'
  }
};

// Get current environment from REACT_APP_ENV or default to production
const getCurrentEnvironment = () => {
  const env = process.env.REACT_APP_ENV || 'prod';
  return environments[env] || environments.prod;
};

export { environments, getCurrentEnvironment };